import * as ActionTypes from '../components/actions/types';

const initialState = {
  storageUsageMB: 0,
  storageLimitMB: 0,
  fileList: []
};

function cmsUploadsListReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_UPLOADS_LIST:
      return {
        fileList: action.payload.fileList,
        storageLimitMB: Number((action.payload.storageLimit / (1024 ** 2)).toFixed(2)),
        storageUsageMB: Number((action.payload.storageUsage / (1024 ** 2)).toFixed(2))
      };

    // eslint-disable-next-line no-case-declarations
    case ActionTypes.DELETE_UPLOADS_LIST_ITEM:
      const updatedUsage = state.storageUsageMB - Number((action.payload.byteSizeToRemove / (1024 ** 2)).toFixed(2));
      return {
        ...state,
        fileList: state.fileList.filter(file => !action.payload.uploadIds.includes(file.objectId)),
        storageUsageMB: Number(updatedUsage.toFixed(2))
      };

    default:
      return state;
  }
}

export default cmsUploadsListReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsUploadsList.js